import { Component, OnInit } from '@angular/core';
import { ManagementService } from '../../core/services/management.service';
import { Router } from '@angular/router';
import {
  NbButtonModule,
  NbCardModule,
  NbDialogRef,
  NbIconModule,
  NbPopoverModule,
} from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { RoleProvider } from '../../auth/role.provider';

import { NbAuthService, NbTokenService } from '@nebular/auth';
import { AUTH_STRATEGY } from '../../shared/constants';

@Component({
  selector: 'app-tenant-disabled',
  imports: [
    NbCardModule,
    TranslateModule,
    NbButtonModule,
    NbIconModule,
    NbPopoverModule,
  ],
  templateUrl: './tenant-disabled-dialog.component.html',
  styleUrl: './tenant-disabled-dialog.component.scss',
})
export class TenantDisabledDialogComponent implements OnInit {
  protected canCloseDialog = false;

  constructor(
    private dialogRef: NbDialogRef<TenantDisabledDialogComponent>,
    private managementService: ManagementService,
    private roleProvider: RoleProvider,
    private nbAuthService: NbAuthService,
    private tokenService: NbTokenService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.roleProvider.isAtLeastAdmin().subscribe((isAdmin) => {
      if (isAdmin) {
        this.canCloseDialog = true;
      }
    });

    if (
      this.managementService.tenant &&
      !this.managementService.tenant?.features?.disabled
    ) {
      // Navigate to the dashboard if the tenant is not disabled
      this.router.navigate(['/dashboard']);
      this.dismiss();
    }
  }

  dismiss(): void {
    this.dialogRef.close();
  }

  logout(): void {
    this.nbAuthService.logout(AUTH_STRATEGY).subscribe(() => {
      this.tokenService.clear();
      this.router.navigate(['/']);
      this.dismiss();
    });
  }
}
